export type Environment = "local" | "staging" | "production";

export const getEnvironment = (): Environment => {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (!environment) {
    throw new Error("REACT_APP_ENVIRONMENT is not set");
  }

  switch (environment) {
    case "local":
      return "local";
    case "staging":
      return "staging";
    case "production":
      return "production";
    default:
      throw new Error(`Unknown environment: ${environment}`);
  }
};
